import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import config from "../../config/Global.json";
import AuthContext from "../../utils/secure-route/AuthContext"; 

const AutoLogin = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [, setLoginStatus] = useState("Initializing auto-login...");
  
  // Get context functions
  const { setManualAuthToken } = useContext(AuthContext);

  useEffect(() => {
    const performAutoLogin = async () => {
      try {
        // Extract refresh token from URL path
        const pathParts = location.pathname.split("/");
        const refreshToken = pathParts[pathParts.length - 1];

        // Validate refresh token
        if (!refreshToken || refreshToken === "autologin") {
          setLoginStatus("No valid token found. Redirecting to login...");
          setTimeout(() => navigate("/login"), 2000);
          return;
        }

        // Store refresh token
        localStorage.setItem("refresh_token", refreshToken);
        setLoginStatus("Token received. Authenticating...");

        // Get access token using refresh token
        const response = await axios.post(
          `${config.api.host}${config.api.refreshToken}`,
          { refresh: refreshToken },
          { 
            headers: { 'Content-Type': 'application/json' },
            timeout: 15000 // 15 second timeout
          }
        );

        // Validate response and save tokens
        if (response.data && response.data.access) {
          // Use the AuthContext function to set tokens properly
          setManualAuthToken(response.data);
          
          // setLoginStatus("Login successful! Redirecting to dashboard...");
          // toast.success("Login successful! Redirecting to dashboard...");
          
          // Redirect to home page after successful login
          setTimeout(() => navigate("/"), 2000);
        } else {
          throw new Error("Failed to obtain access token");
        }
      } catch (error) {
        console.error("Auto login failed:", error);
        
        let errorMessage = "Auto login failed. Redirecting to login page.";
        
        // More specific error messages based on the error
        if (error.response) {
          if (error.response.status === 401) {
            errorMessage = "Invalid or expired token. Please try again.";
          } else if (error.response.status === 429) {
            errorMessage = "Too many login attempts. Please try again later.";
          } else if (error.response.status >= 500) {
            errorMessage = "Server error. Please try again later.";
          }
        } else if (error.code === "ECONNABORTED") {
          errorMessage = "Connection timeout. Please check your internet connection.";
        }
        
        setLoginStatus(errorMessage);
        toast.error(errorMessage);
        
        // Clear any partial authentication data
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("authToken");
        
        setTimeout(() => navigate("/login"), 2000);
      }
    };

    performAutoLogin();
  }, [location.pathname, navigate, setManualAuthToken]);

  return (
    <div
      className="auto-login-container"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        flexDirection: "column",
        backgroundColor: "#f8f9fa",
      }}
    >
      <div style={{ 
        padding: "2rem", 
        borderRadius: "8px", 
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)", 
        backgroundColor: "white",
        textAlign: "center",
        maxWidth: "400px",
        width: "90%"
      }}>
        <h2 style={{ color: "#333", marginBottom: "1rem" }}>
          {config.appName} Auto Login
        </h2>
        {/* <p style={{ color: "#666", marginBottom: "1.5rem" }}>{loginStatus}</p> */}
        <div className="loading-spinner" style={{
          border: "4px solid #f3f3f3",
          borderTop: "4px solid #3498db",
          borderRadius: "50%",
          width: "30px",
          height: "30px",
          animation: "spin 2s linear infinite",
          margin: "0 auto"
        }}></div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default AutoLogin;